module.exports = __webpack_public_path__ + "static/media/6.be6428b5.png";